import { OrderInfoItems } from './orderInfoItems';

export class OrderInfoModel {

    constructor() {
        this.orderItems = new OrderInfoItems();
    }
    orderId: string;
    orderCount: number;
    sheedAccount: number;
    discount: number;
    totalPrice: number;
    customerContact: string;
    discountAmount: number;
    vATAmount: number;
    orderItems: OrderInfoItems;
}